import { render, staticRenderFns } from "./ShowMore.vue?vue&type=template&id=1c386e68"
import script from "./ShowMore.vue?vue&type=script&lang=js"
export * from "./ShowMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports